import { Component, OnInit,EventEmitter,Input,Output } from '@angular/core';
import {LoginService} from '../login.service'
@Component({
    selector: 'app-searchbox',
    templateUrl: './searchbox.component.html',
    styleUrls: ['./searchbox.component.scss'],
    standalone: false
})
export class SearchboxComponent implements OnInit {
  @Output() closed = new EventEmitter<any[]>();
  @Output() closeReports=new EventEmitter<any[]>();
  @Input('startdate') startdate:Date;
  @Input('enddate') enddate:Date;
  @Input('exams') exams;
  @Input('examtype') etype='All';
  @Input('reportstype') reportstype='AllReports';
  @Input('hmostype') hmostype='Macabi';


  @Input('isUSG') isUSG;
  @Input('isReports') isReports;
  searchmin:any = null;
  searchmax:any = null;
  
  months = [
    { name: 'January', value: 0 },
    { name: 'February', value: 1 },
    { name: 'March', value: 2 },
    { name: 'April', value: 3 },
    { name: 'May', value: 4 },
    { name: 'June', value: 5 },
    { name: 'July', value: 6 },
    { name: 'August', value: 7 },
    { name: 'September', value: 8 },
    { name: 'October', value: 9 },
    { name: 'November', value: 10 },
    { name: 'December', value: 11 }
  ];
  years = [];
  selectedMonth: number;
  selectedYear: number;
  
  cansearch=true;

  constructor(public ls: LoginService) { }

  ngOnInit() {
    if(this.ls.LeumitAdmin){
      this.searchmax = new Date(new Date().setDate(new Date().getDate() - 1));
      this.enddate = this.searchmax;
      
      this.searchmin = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      this.searchmin.setDate(this.searchmin.getDate() -1 );
     
    }

    // Setup years for picker: only 1 year back and up to present year
    const now = new Date();
    const startYear = now.getFullYear() - 1;
    for(let y = startYear; y <= now.getFullYear(); y++) {
      this.years.push(y);
    }

    const persistedMonthDate = this.reportstype === 'Macabifin' ? this.toDate(this.startdate) : null;
    if (persistedMonthDate) {
      this.selectedMonth = persistedMonthDate.getMonth();
      this.selectedYear = persistedMonthDate.getFullYear();
      return;
    }

    // Default to last month
    let lastMonth = now.getMonth() - 1;
    let lastMonthYear = now.getFullYear();
    if (lastMonth < 0) {
      lastMonth = 11;
      lastMonthYear--;
    }
    this.selectedMonth = lastMonth;
    this.selectedYear = lastMonthYear;

  }

  private toDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    if (value._d instanceof Date) {
      return isNaN(value._d.getTime()) ? null : value._d;
    }
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  search(){
    let vals = [this.startdate,this.enddate,this.exams, this.etype];
    if(this.isReports)
      vals  = [this.startdate, this.enddate, [] , this.reportstype, this.hmostype]

    // If Macabifin, override start/end dates to beginning/end of selected month
    if(this.reportstype === 'Macabifin') {
      const start = new Date(this.selectedYear, this.selectedMonth, 1);
      // Calculate last day of selected month/year
      const end = new Date(this.selectedYear, this.selectedMonth, 1);
      end.setMonth(end.getMonth() + 1);
      end.setDate(0); // last day of previous month
      vals[0] = start;
      vals[1] = end;
    }
    this.closed.emit(vals);
  }

  setVals(mode:string){
    switch(mode){
      case 'All':
        for(let e in this.exams){
          this.exams[e]=true;
        }
        break;
      case 'OB':
        for(let e in this.exams){
          this.exams[e]=true;
          if(e == 'Amniocentesis' || e == 'CVS' || e == 'Follicles'){
            this.exams[e] = false;
          }
        }
        this.exams.Gynecology = false;
        break;
      case 'Ultrasound':
        for(let e in this.exams){
          this.exams[e]=true;
        }
        this.exams.Gynecology = false;
      break;
      case 'Endoscopy':
        for(let e in this.exams){
          this.exams[e]=false;
        }
        this.exams['Endoscopy'] = true;
      break;
      case 'GYN':
        for(let e in this.exams){
          this.exams[e]=false;
        }
        this.exams.Gynecology = true;
      break;
      case 'Invasive':
        for(let e in this.exams){
          this.exams[e] = false;
          if(e == 'Amniocentesis' || e == 'CVS' || e == 'Follicles'){
            this.exams[e] = true;
          }
        }
        this.exams.Gynecology = false;
      break;
      case 'Refferelnum':case 'HMO':case 'Macabi':case 'AllReports':case 'Macabifin':
        this.cansearch = true
        
        break;
    }
    this.cansearch = this.hasExam();
    
  }
  setE(event,exam:string){
    if(event.srcElement.type != 'checkbox')
      return;
    this.exams[exam]=!this.exams[exam];
    this.cansearch = this.hasExam();
  }

  hasExam():boolean{
    if(! this.exams)
      return false;
    for(let e in this.exams)
      if(this.exams[e])
        return true;
    //if nothing    
    return false;
  }

}
